import API from '../../API/api';
import Dispatcher from '../dispatcher';
import {
    IS_FETCHING_SUGGESTIONS_ACTION_TYPE,
    UPDATE_SUGGESTIONS_ACTION_TYPE,
    HIDE_SUGGESTIONS_ACTION_TYPE,
} from '../stores/search_store';

class SearchActions {

    static hideSuggestions() {
        Dispatcher.dispatch({
            type: HIDE_SUGGESTIONS_ACTION_TYPE,
            payload: true,
        });
    }

    static async fetchSuggestionsFor(term) {
        Dispatcher.dispatch({
            type: IS_FETCHING_SUGGESTIONS_ACTION_TYPE,
            payload: true,
        });

        const response = await API.GET({
            apiPath: '/api/search/',
            dataType: 'json',
            data: {
                q: term,
            },
        });

        Dispatcher.dispatch({
            type: IS_FETCHING_SUGGESTIONS_ACTION_TYPE,
            payload: false,
        });

        if (response.success) {
            Dispatcher.dispatch({
                type: UPDATE_SUGGESTIONS_ACTION_TYPE,
                payload: response.suggestions,
            });
        }
    }
}

export default SearchActions;
